/* ============================================================================
 * BOELLE custom wishlist — storefront logic
 * ==========================================================================*/
(function () {
  'use strict';

  var CFG = window.BoelleWishlist || {};
  var PROXY = CFG.proxyBase || '/apps/wishlist';
  var LOGGED_IN = !!CFG.loggedIn;
  var PENDING_KEY = 'boelle:wishlist:pending';

  var L = CFG.labels || {};
  function t(key, fallback) { return L[key] || fallback; }

  var state = new Map();

  function seedState() {
    state.clear();
    if (LOGGED_IN && Array.isArray(CFG.initial)) {
      CFG.initial.forEach(function (it) { if (it && it.handle) state.set(it.handle, it); });
    }
  }

  function postProxy(path, payload) {
    return fetch(PROXY + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload || {}),
      credentials: 'same-origin',
    }).then(function (r) { return r.json(); });
  }
  function applyServerItems(res) {
    if (res && res.ok && Array.isArray(res.items)) {
      state.clear();
      res.items.forEach(function (it) { state.set(it.handle, it); });
      syncUI();
    }
  }

  // ---- serialize proxy writes ----------------------------------------------
  // Every heart triggers a read-modify-write of the whole wishlist metafield.
  // If several run at once they clobber each other ("last write wins") and
  // items get lost. Queue them so only one is in flight at a time, and only
  // reconcile the UI with the server once the queue drains — so a late
  // response can't un-fill a heart the user just clicked.
  var opChain = Promise.resolve();
  var opsPending = 0;
  function enqueueSync(fn) {
    opsPending++;
    var result = opChain.then(function () { return fn(); });
    opChain = result.then(function () { opsPending--; }, function () { opsPending--; });
    return result;
  }
  function syncToggle(payload) {
    return enqueueSync(function () { return postProxy('/toggle', payload); })
      .then(function (res) { if (opsPending === 0) applyServerItems(res); })
      .catch(function () { /* keep optimistic state; reconciles next load */ });
  }

  function itemFromButton(btn) {
    var d = btn.dataset;
    return {
      id: d.wishlistId || '',
      handle: d.wishlistHandle || '',
      title: d.wishlistTitle || '',
      image: d.wishlistImage || '',
      price: d.wishlistPrice || '',
      url: d.wishlistUrl || (d.wishlistHandle ? '/products/' + d.wishlistHandle : ''),
      addedAt: new Date().toISOString(),
    };
  }

  function refreshButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-button]').forEach(function (btn) {
      var handle = btn.dataset.wishlistHandle;
      var active = state.has(handle);
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = active ? t('remove', 'Remove from wishlist') : t('add', 'Add to wishlist');
      if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
      var txt = btn.querySelector('[data-wishlist-text]');
      if (txt && txt.textContent !== label) txt.textContent = label;
    });
  }
  function refreshCount() {
    var n = state.size;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.toggleAttribute('hidden', n === 0);
      el.classList.toggle('is-empty', n === 0);
    });
  }
  function syncUI(root) { refreshButtons(root); refreshCount(); renderGrid(); }

  function toggle(btn) {
    var item = itemFromButton(btn);
    if (!item.handle) return;
    if (!LOGGED_IN) {
      setPending(item);
      openAccountPopup();
      return;
    }
    var wasActive = state.has(item.handle);
    if (wasActive) state.delete(item.handle);
    else state.set(item.handle, item);
    syncUI();
    pulse(btn, !wasActive);
    syncToggle({ item: item });
    document.dispatchEvent(new CustomEvent('boelle:wishlist:change', {
      detail: { handle: item.handle, added: !wasActive, count: state.size },
    }));
  }

  function pulse(btn, added) {
    if (!added) return;
    btn.classList.remove('wishlist-pulse');
    void btn.offsetWidth;
    btn.classList.add('wishlist-pulse');
  }

  function setPending(item) {
    try { localStorage.setItem(PENDING_KEY, JSON.stringify(item)); } catch (e) {}
  }
  function getPending() {
    try { return JSON.parse(localStorage.getItem(PENDING_KEY)); } catch (e) { return null; }
  }
  function clearPending() { try { localStorage.removeItem(PENDING_KEY); } catch (e) {} }

  var popupEl = null;
  function openAccountPopup() {
    if (popupEl) { popupEl.classList.add('is-open'); document.body.classList.add('boelle-wl-noscroll'); return; }
    var registerUrl = CFG.registerUrl || '/account/register';
    var loginUrl = CFG.loginUrl || '/account/login';
    var returnTo = encodeURIComponent(window.location.pathname + window.location.search);
    var sep = (registerUrl.indexOf('?') >= 0) ? '&' : '?';
    var sepL = (loginUrl.indexOf('?') >= 0) ? '&' : '?';

    popupEl = document.createElement('div');
    popupEl.className = 'boelle-wl-modal is-open';
    popupEl.setAttribute('role', 'dialog');
    popupEl.setAttribute('aria-modal', 'true');
    popupEl.setAttribute('aria-label', t('popupTitle', 'Create an account to save favourites'));
    popupEl.innerHTML =
      '<div class="boelle-wl-modal__backdrop" data-wl-close></div>' +
      '<div class="boelle-wl-modal__dialog">' +
        '<button class="boelle-wl-modal__x" data-wl-close aria-label="' + esc(t('close', 'Close')) + '">&times;</button>' +
        '<div class="boelle-wl-modal__heart" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M12 20.5l-1.45-1.32C5.4 14.36 2 11.28 2 7.5 2 4.9 4.04 3 6.5 3c1.74 0 3.41.81 4.5 2.09C12.09 3.81 13.76 3 15.5 3 17.96 3 20 4.9 20 7.5c0 3.78-3.4 6.86-8.55 11.68L12 20.5z" fill="#b34a4a"/></svg>' +
        '</div>' +
        '<h2 class="boelle-wl-modal__title">' + esc(t('popupTitle', 'Create an account to save favourites')) + '</h2>' +
        '<p class="boelle-wl-modal__text">' + esc(t('popupText', 'Save the things you love and find them on any device. It only takes a moment.')) + '</p>' +
        '<a class="boelle-wl-modal__primary" href="' + esc(registerUrl + sep + 'return_url=' + returnTo) + '">' + esc(t('popupCreate', 'Create an account')) + '</a>' +
        '<a class="boelle-wl-modal__secondary" href="' + esc(loginUrl + sepL + 'return_url=' + returnTo) + '">' + esc(t('popupLogin', 'I already have an account')) + '</a>' +
      '</div>';
    document.body.appendChild(popupEl);
    document.body.classList.add('boelle-wl-noscroll');

    popupEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-wl-close]')) closeAccountPopup();
    });
    document.addEventListener('keydown', escClose);
  }
  function closeAccountPopup() {
    if (!popupEl) return;
    popupEl.classList.remove('is-open');
    document.body.classList.remove('boelle-wl-noscroll');
    document.removeEventListener('keydown', escClose);
  }
  function escClose(e) { if (e.key === 'Escape') closeAccountPopup(); }

  function processPendingAfterLogin() {
    if (!LOGGED_IN) return;
    var pending = getPending();
    if (!pending || !pending.handle) return;
    if (state.has(pending.handle)) { clearPending(); return; }
    enqueueSync(function () { return postProxy('/toggle', { item: pending }); })
      .then(function (res) { clearPending(); if (opsPending === 0) applyServerItems(res); })
      .catch(function () {});
  }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    if (!LOGGED_IN) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var items = Array.from(state.values());
    if (empty) empty.toggleAttribute('hidden', items.length > 0);
    grid.toggleAttribute('hidden', items.length === 0);

    grid.innerHTML = items.map(function (it) {
      return (
        '<li class="boelle-wl-card">' +
          '<a class="boelle-wl-card__media" href="' + esc(it.url) + '">' +
            (it.image ? '<img loading="lazy" src="' + esc(it.image) + '" alt="' + esc(it.title) + '">' : '') +
          '</a>' +
          '<div class="boelle-wl-card__body">' +
            '<a class="boelle-wl-card__title" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
            '<div class="boelle-wl-card__price">' + esc(it.price) + '</div>' +
            '<div class="boelle-wl-card__actions">' +
              '<button type="button" class="boelle-wl-card__add" data-wishlist-addcart data-handle="' + esc(it.handle) + '">' +
                esc(t('addToCart', 'Add to cart')) + '</button>' +
              '<button type="button" class="boelle-wl-card__remove" data-wishlist-remove data-handle="' + esc(it.handle) + '" aria-label="' + esc(t('remove', 'Remove')) + '">&times;</button>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }).join('');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Update the header cart-count badge (FoxTheme.pubsub cartUpdate).
  function publishCartUpdate() {
    try {
      var pubsub = window.FoxTheme && FoxTheme.pubsub;
      if (!pubsub || !pubsub.PUB_SUB_EVENTS || !pubsub.PUB_SUB_EVENTS.cartUpdate) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'boelle-wishlist', cart: cart });
        })
        .catch(function () {});
    } catch (e) {}
  }

  function addToCart(handle, btn) {
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var hasDrawer = !!document.querySelector('cart-drawer');

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var variant = (p.variants || []).find(function (v) { return v.available; }) || p.variants[0];
        if (!variant) throw new Error('no variant');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
          credentials: 'same-origin',
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('boelle:wishlist:addedToCart', { detail: { handle: handle } }));
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
        publishCartUpdate();
        if (hasDrawer) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        } else if (btn) {
          btn.classList.add('is-added');
          btn.textContent = '✓ ' + t('added', 'Tillagd i varukorgen');
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = originalText;
          }, 1900);
        }
      })
      .catch(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; btn.textContent = originalText; }
        window.location.href = '/products/' + handle;
      });
  }

  function removeByHandle(handle) {
    if (!LOGGED_IN) return;
    state.delete(handle);
    syncUI();
    syncToggle({ item: { handle: handle } });
  }

  // Keep the cart drawer's close (X) working after a cart:refresh re-render.
  function bindCartDrawerClose() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || cd.__boelleCloseBound) return;
    cd.__boelleCloseBound = true;
    cd.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('.drawer__close-btn');
      if (!closeBtn) return;
      var controls = closeBtn.getAttribute('aria-controls') || '';
      if (controls.indexOf('CartDrawer') !== 0) return;
      if (typeof cd.hide === 'function') { e.preventDefault(); cd.hide(); }
    });
  }

  // Inject a wishlist heart link into the header, next to the account icon.
  function insertHeaderWishlistLink() {
    document.querySelectorAll('.header__buttons').forEach(function (group) {
      var account = group.querySelector('.account-button');
      var cart = group.querySelector('.cart-drawer-button');
      if (!account && !cart) return;
      if (group.querySelector('.header__wishlist-link')) return;
      var link = document.createElement('a');
      link.href = '/pages/wishlist';
      link.className = 'header__wishlist-link flex items-center justify-center relative';
      link.style.color = 'inherit';
      link.setAttribute('aria-label', t('wishlistNav', 'Önskelista'));
      link.innerHTML =
        '<svg class="icon icon--large icon--thick shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M12 20.5l-1.45-1.32C5.4 14.36 2 11.28 2 7.5 2 4.9 4.04 3 6.5 3c1.74 0 3.41.81 4.5 2.09C12.09 3.81 13.76 3 15.5 3 17.96 3 20 4.9 20 7.5c0 3.78-3.4 6.86-8.55 11.68L12 20.5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
        '</svg>' +
        '<span class="boelle-wl-countbadge" data-wishlist-count hidden style="position:absolute;top:-6px;inset-inline-end:-8px;">0</span>';
      group.insertBefore(link, account || cart);
    });
    refreshCount();
  }

  function shareWishlist() {
    var handles = Array.from(state.keys());
    var url = window.location.origin + '/pages/wishlist?items=' + encodeURIComponent(handles.join(','));
    if (navigator.share) {
      navigator.share({ title: 'My BOELLE wishlist', url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(flashShared);
    } else {
      window.prompt('Copy your wishlist link:', url);
    }
  }
  function flashShared() {
    var el = document.querySelector('[data-wishlist-share]');
    if (!el) return;
    var prev = el.textContent;
    el.textContent = t('copied', 'Link copied!');
    setTimeout(function () { el.textContent = prev; }, 1800);
  }

  function onClick(e) {
    var toggleBtn = e.target.closest('[data-wishlist-button]');
    if (toggleBtn) { e.preventDefault(); toggle(toggleBtn); return; }
    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) { e.preventDefault(); removeByHandle(rm.dataset.handle); return; }
    var add = e.target.closest('[data-wishlist-addcart]');
    if (add) { e.preventDefault(); addToCart(add.dataset.handle, add); return; }
    var share = e.target.closest('[data-wishlist-share]');
    if (share) { e.preventDefault(); shareWishlist(); return; }
  }

  function init() {
    if (window.__boelleWLInit) return; // guard against double-load (double toggles)
    window.__boelleWLInit = true;
    seedState();
    processPendingAfterLogin();
    syncUI();
    document.addEventListener('click', onClick);
    bindCartDrawerClose();
    insertHeaderWishlistLink();
    var moPending = false;
    var mo = new MutationObserver(function () {
      if (moPending) return;
      moPending = true;
      requestAnimationFrame(function () {
        moPending = false;
        mo.disconnect();
        refreshButtons();
        mo.observe(document.body, { childList: true, subtree: true });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.BoelleWishlist = Object.assign(CFG, {
    getItems: function () { return Array.from(state.values()); },
    has: function (h) { return state.has(h); },
    refresh: syncUI,
  });
})();